import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import subDays from 'date-fns/subDays';
import { useSelector } from 'react-redux';

import { State } from '../reducer';
import { Container } from '../components/MenuBar';
import NavGroup from '../components/MenuBar/NavGroup';
import { useAccountId } from '../auth/useAccountId';
import { namespace } from './customers';

const today = new Date();
const thirtyDaysAgo = subDays(today, 30);

const MenuInternal = (
    {
        t,
        accountId,
    }: {
        t: TFunction;
        accountId: string;
    }
) => {
    const count = useSelector<State, number| undefined>(
        (s) => s[namespace].totalCount
    );
    return (
        <Container>
            <NavGroup
                mainLink={{
                    path: `/${accountId}/customers`,
                    label: t('customers.menu.all'),
                    count: count,
                }}
                subLinks={[]}
            />
            <NavGroup
                mainLink={{
                    path: `/${accountId}/customers?since_datetime=${thirtyDaysAgo.toISOString()}`,
                    label: t('customers.menu.registered_last_30'),
                }}
                subLinks={[]}
            />
        </Container>
    );
};

const MenuInternalMemo = memo(MenuInternal);

const Menu = () => {
    const { t } = useTranslation();
    const accountId = useAccountId();
    return <MenuInternalMemo t={t} accountId={accountId} />;
};

export default Menu;
